import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { EBAY_URL } from "@/components/Header";
import { OPENING_HOURS_DISPLAY } from "@/constants/openingHours";

const Footer = () => (
  <footer
    data-testid={TESTIDS.footer}
    className="bg-[var(--pz-text)] text-white"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <img
            src="/logo.png"
            alt="Prozenthaus Logo"
            width="180"
            height="56"
            loading="lazy"
            decoding="async"
            className="h-12 w-auto"
            style={{ filter: "invert(1) brightness(1.05)" }}
          />
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            Markenware bis 50% reduziert. Ihr Einzelhandel für Lagerrestbestände,
            Überschusswaren und Sonderposten in Schenklengsfeld.
          </p>
          <a
            href={EBAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={TESTIDS.footerEbayLink}
            className="pz-btn pz-btn-primary mt-6"
          >
            Zum eBay-Shop <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="lg:col-span-3">
          <div className="pz-eyebrow text-white/60 mb-4">Kontakt</div>
          <address className="not-italic space-y-2 text-sm">
            <div className="font-semibold">Ron Kowalewsky</div>
            <div className="text-white/70">
              Landeckerstraße 20A
              <br />
              36277 Schenklengsfeld
            </div>
            <a
              href="tel:+4966292160485"
              data-testid={TESTIDS.footerPhoneLink}
              className="block text-white/70 hover:text-white"
            >
              Tel: 06629 2160485
            </a>
            <a
              href="mailto:team@prozenthaus.shop"
              data-testid={TESTIDS.footerEmailLink}
              className="block text-white/70 hover:text-white"
            >
              team@prozenthaus.shop
            </a>
          </address>
          <div className="mt-6">
            <div className="pz-eyebrow text-white/60 mb-3">Öffnungszeiten</div>
            <dl
              data-testid="footer-opening-hours"
              className="text-xs space-y-1.5"
            >
              {OPENING_HOURS_DISPLAY.map((row) => (
                <div key={row.range} className="flex justify-between gap-3">
                  <dt className="text-white/55">{row.range}</dt>
                  <dd
                    className={
                      row.hours === "Geschlossen"
                        ? "text-white/45"
                        : "text-white font-semibold"
                    }
                  >
                    {row.hours}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

        <div className="lg:col-span-4">
          <div className="pz-eyebrow text-white/60 mb-4">Warenbereiche</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Baumarkt, Garten, Elektro & Smart</li>
            <li>Camping, Freizeit & Outdoor</li>
            <li>Haushaltsgeräte, Küche & Wohnen</li>
            <li>PC, IT, Büro, Drucker, Uhren & Handys</li>
            <li>Multimedia, Audio, Video, HiFi & DAB</li>
            <li>Heimwerken & Werkzeuge</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-white/50">
        <div>© {new Date().getFullYear()} Prozenthaus · Inh. Ron Kowalewsky</div>
        <div className="flex items-center gap-6">
          <Link
            to="/impressum"
            data-testid={TESTIDS.footerImpressumLink}
            className="hover:text-white"
          >
            Impressum
          </Link>
          <Link
            to="/datenschutz"
            data-testid={TESTIDS.footerDatenschutzLink}
            className="hover:text-white"
          >
            Datenschutz
          </Link>
          <span className="hidden sm:inline">Markenware bis 50% reduziert</span>
        </div>
      </div>

      <div
        data-testid="footer-credit"
        className="mt-6 pt-5 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm text-white/75"
      >
        <div>
          Erstellt durch{" "}
          <a
            href="https://www.it-servicepoint.eu"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-link"
            className="text-[var(--pz-accent)] font-bold hover:text-[var(--pz-accent-light)] underline-offset-4 hover:underline"
          >
            IT-Servicepoint
          </a>{" "}
          · Wir erstellen auch Ihre Webseite.
        </div>
        <a
          href="mailto:info@it-servicepoint.eu"
          data-testid="footer-credit-email"
          className="font-semibold hover:text-white"
        >
          Kontakt: info@it-servicepoint.eu
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
